export function itemTypeToLabel(type) {
    switch (type) {
        case null:
        case undefined:
            return 'Item';
        case 'PRODUCT':
            return 'Product';
        case 'SERVICE':
            return 'Service';
        default:
            return 'Unknown';
    }
}